import { Pipe, PipeTransform } from '@angular/core';
import { IS_EMPTY } from 'cargo-chief-commons';

@Pipe({
	name: 'timeRange',
})
export class TimeRangePipe implements PipeTransform {
	toHHMM(v: any): string {
		if (IS_EMPTY(v)) return '';
		const s = String(v).trim().toLowerCase();
		if (s === 'null' || s === 'undefined') return '';
		const m = s.match(/^\d{2}:\d{2}/);
		return m ? m[0] : s;
	}

	transform(open: any, close?: any): string {
		const o = this.toHHMM(open);
		const c = this.toHHMM(close);

		if (o && c) return `${o} - ${c}`;
		if (o) return o;
		if (c) return c;
		return '';
	}
}
